export default interface ModbusSensorBase {
  registerAddress: number;
  dataType: ModbusReturnedDataType;
}

export type ModbusReturnedDataType =
  | 'HEX'
  | 'UINT16'
  | 'INT16'
  | 'UINT32'
  | 'INT32'
  | 'UINT64'
  | 'INT64'
  | 'FLOAT32'
  | 'FLOAT64'
  | 'STRING'
  | 'BITMASK'
  | 'COMPOSITE_DECIMAL';

export const defaultModbusSensorBase: ModbusSensorBase = {
  registerAddress: 0,
  //currently most registers are of this type, so it is set as the default when adding a new sensor
  dataType: 'FLOAT32',
};
